import React, { FC } from 'react'
import { Progress } from 'antd'
import { ProgressProps as AntProgressBar } from 'antd/lib/progress'

export type ProgressProps = AntProgressBar

export const ProgressBar: FC<ProgressProps> = ({
  strokeColor,
  percent,
  status,
  showInfo = false,
  type,
  width,
  strokeWidth,
  trailColor,
  ...rest
}) => {
  return (
    <Progress
      strokeColor={strokeColor}
      percent={percent}
      status={status}
      showInfo={showInfo}
      type={type}
      width={width}
      strokeWidth={strokeWidth}
      trailColor={trailColor}
      {...rest}
    />
  )
}
